module.exports = __webpack_public_path__ + "static/media/home icon.e4ac944a.svg";